const custom_es = require('./custom.json')
export default custom_es